import * as React from 'react';

var _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgS = function SvgS(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#141416",
        d: "M60.001 0zC26.863 0 0 26.863 0 60s26.863 60 60 60h.001c33.137 0 60-26.863 60-60s-26.863-60-60-60"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#F5F5F5",
        d: "M70.714 72.737C50.87 78.69 34.455 87.374 24.18 97.548l-.454.452a53.2 53.2 0 0 0 8.967 6.856l.697-.85a132 132 0 0 1 8.946-9.85c8.408-8.368 18.03-15.613 28.389-21.43zM7.5 63.917a52.05 52.05 0 0 0 10.93 28.266l.285-.284c6.361-6.268 14.643-11.97 24.634-16.936 8.756-4.358 18.81-8.096 29.644-11.046zM47.885 20.289C65.64 37.961 87.984 49.647 112.49 54.078 109.537 27.881 87.214 7.5 60.091 7.5a52.9 52.9 0 0 0-20.224 4 130 130 0 0 0 8.018 8.789M24.18 22.452C34.455 32.637 50.87 41.31 70.714 47.274c-10.36-5.827-19.98-13.062-28.389-21.43a133 133 0 0 1-8.946-9.85l-.696-.85a52.8 52.8 0 0 0-8.957 6.857zM47.885 99.711a124 124 0 0 0-8.018 8.789 52.9 52.9 0 0 0 20.224 4c27.123 0 49.446-20.38 52.411-46.589-24.507 4.431-46.852 16.118-64.607 33.79zM43.349 45.038C33.358 40.07 25.077 34.37 18.715 28.1l-.285-.284A52.05 52.05 0 0 0 7.5 56.085h65.483c-10.835-2.951-20.878-6.689-29.645-11.057z"
    })));
};

export { SvgS as ReactComponent };
//# sourceMappingURL=S.svg.es.js.map
